var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import moment from 'moment';
import { isTutor, UserType } from '@gopeerproject/chuck';
import { createStyleSheet } from '../../../utils';
import { useStyleSheet } from '../../../hooks';
import { Icon } from '../../Icon';
import { Text } from '../../Text';
import { View } from '../../View';
import { User } from '../../User';
import { Link } from '../../Link';
import { Divider } from '../../Divider';
import { Button } from '../../Button';
export const Fallback = (_a) => {
    var { viewProfile, participants } = _a, props = __rest(_a, ["viewProfile", "participants"]);
    const styles = useStyleSheet(getStyles);
    const tutor = participants.find(({ type }) => isTutor(type));
    return (React.createElement(View, { style: styles.container }, props.templates !== undefined ? (React.createElement(React.Fragment, null,
        React.createElement(User, { name: tutor.name, image: tutor.image, size: 'lg', type: UserType.TUTOR }),
        React.createElement(Text, { type: 'heading', size: 'h6', style: styles.name }, tutor.name),
        React.createElement(Text, { type: 'body', size: 'md', weight: 'regular', style: styles.activity }, tutor.online
            ? `${tutor.name} is online right now`
            : `Last active ${moment(tutor.lastActiveAt).calendar(null, {
                sameDay: '[today]',
                lastDay: '[yesterday]',
                lastWeek: '[last] dddd',
                sameElse: 'dddd, MMMM Do'
            })}`),
        !!viewProfile && (React.createElement(Link, { type: 'primary', text: 'View profile', onPress: () => {
                viewProfile(tutor.id);
            }, style: styles.link })),
        React.createElement(Divider, { style: styles.divider, type: 'horizontal' }),
        React.createElement(Text, { type: 'body', size: 'md', weight: 'regular', style: styles.suggestedMessagesTitle }, "Click to send suggested messages"),
        React.createElement(View, { style: styles.templates }, props.templates.slice(0, 3).map((template, index) => (React.createElement(Button, { key: template.id, type: 'secondary', accent: 'neutral', size: 'md', text: template.name, onPress: () => {
                props.onTemplateSend(template);
            }, style: index === 0 ? {} : styles.buttonWithMargin })))))) : (React.createElement(React.Fragment, null,
        React.createElement(Icon, { name: 'chat', size: 34 }),
        React.createElement(Text, { style: styles.textWithMargin, type: 'heading', size: 'h6' }, "Nothing to see here yet"),
        React.createElement(Text, { type: 'body', size: 'md', weight: 'regular' }, "You don't have any messages yet")))));
};
const getStyles = createStyleSheet(({ size, color }) => ({
    container: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
        padding: size.K
    },
    textWithMargin: {
        marginVertical: size.C
    },
    name: {
        marginTop: size.C,
        color: color.invert2.p100
    },
    link: {
        marginTop: size.G
    },
    divider: {
        marginVertical: size.K
    },
    suggestedMessagesTitle: {
        color: color.invert2.p56
    },
    buttonWithMargin: {
        marginTop: size.C
    },
    templates: {
        marginTop: size.G,
        alignItems: 'center'
    },
    activity: {
        marginTop: size.B,
        color: color.invert2.p56
    }
}));
//# sourceMappingURL=Fallback.js.map